export default {"src":"/_next/static/media/bank_color.544fbb8b.svg","height":32,"width":32};